import { Modal, Table } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function OrganizationModal(props: any) {
  const currentRecord = useSelector((state: RootState) => state.UsersPageState.currentRecord);

  const OrganizationModalContent = () => {
    return (
      <div style={{ width: "100%" }}>
        <h4>Organizations</h4>
        <Table
          columns={[
            {
              title: "Name",
              dataIndex: "",
              key: "name",
              render: (text: string) => <a>{text}</a>,
            },
          ]}
          className="table"
          dataSource={currentRecord.tenants}
          pagination={{
            pageSize: 5,
          }}
          scroll={{ y: 300 }}
          size="small"
          bordered
        />
      </div>
    );
  };

  return (
    <Modal
      centered
      zIndex={1500}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      <OrganizationModalContent />
    </Modal>
  );
}

export default OrganizationModal;
